/* Resolve legacy color names from the same palette used by collection cards. */
(() => {
  if (window.cherryProductCardsReady) return;
  window.cherryProductCardsReady = true;
  let palette;
  const normalize = value => value.toLowerCase().replace(/\s/g, '');
  async function init(root) {
    const swatches = [...root.querySelectorAll('[data-cherry-card-swatch]')];
    swatches.forEach(swatch => {
      const color = normalize(swatch.dataset.cherryCardSwatch);
      if (CSS.supports('color', color)) swatch.style.setProperty('--swatch', color);
    });
    if (!swatches.length || !window.theme?.assets?.swatches) return;
    try {
      palette ||= fetch(window.theme.assets.swatches).then(response => {
        if (!response.ok) throw new Error('Swatch palette unavailable');
        return response.json();
      });
      const { colors = [] } = await palette;
      swatches.forEach(swatch => {
        const name = normalize(swatch.dataset.cherryCardSwatch);
        const match = colors.find(color => normalize(Object.keys(color)[0]) === name);
        if (!match) return;
        const value = Object.values(match)[0];
        if (/\.(png|jpe?g|svg)(\?|$)/i.test(value)) {
          swatch.style.backgroundImage = `url("${window.theme.assets.base || '/'}${value}")`;
        } else swatch.style.setProperty('--swatch', value);
      });
    } catch (_) { palette = undefined; /* Keep the server-rendered swatches usable. */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('cherry:swatches:load', event => init(event.detail.root));
})();
